import * as AK from '@ariakit/react'
import type {ReactNode} from 'react'
import {BaseCheckbox} from './BaseCheckbox'
import {Field, type FieldPropsBase} from './Field'

interface FormCheckboxProps extends Omit<AK.FormCheckboxProps, 'render'> {
  label: ReactNode
}

const FormCheckbox = ({label, ...props}: FormCheckboxProps) => (
  <AK.FormCheckbox
    clickOnEnter
    render={<BaseCheckbox label={label} />}
    {...props}
  />
)

interface CheckboxFieldProps
  extends Omit<FieldPropsBase, 'label'>,
    Omit<FormCheckboxProps, 'size' | 'type'> {
  fieldLabel?: FieldPropsBase['label']
}

const CheckboxField = ({
  name,
  fieldLabel,
  rightLabel,
  hint,
  size,
  type: _type,
  ...props
}: CheckboxFieldProps) => (
  <Field
    name={name}
    label={fieldLabel}
    rightLabel={rightLabel}
    hint={hint}
    size={size}
    type="checkbox"
  >
    <FormCheckbox name={name} {...props} />
  </Field>
)

export type {CheckboxFieldProps as CheckboxProps}

export const Checkbox = Object.assign(CheckboxField, {Input: FormCheckbox})
